import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';

@Component({
  selector: 'app-mapped-fields',
  standalone: false,
  templateUrl: './mapped-fields.component.html',
  styleUrl: './mapped-fields.component.scss'
})
export class MappedFieldsComponent implements OnInit {
  translate: any;
  tableData: any[] = [];
  data: any;

  constructor(
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService
  ) { }

  ngOnInit(): void {
    this.getLanguageData();
    console.log(this.data, 'data printing in modal')
    this.tableData = this.data.data;

  }

  //Language
  getLanguageData() {
    this.languageTranslateService.wordSrc$.subscribe((data) => {
      if (Object.keys(data).length != 0) {
        this.translate = data
      }
    })
  }

  onCancelClick() {
    this.modalRef.hide();
  }
}
